// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://use.typekit.net/xxi0uje.css);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".er-flow__viewport{align-items:center;display:flex;justify-content:center;min-height:100vh;padding:40px 20px}.er-flow__wrap{position:relative;width:100%;z-index:1}.er-flow__wrap>div>.v-card{margin-left:auto;margin-right:auto}.er-flow__foot{color:#5a6a6a;font-size:14.5px;margin-bottom:0;margin-top:34px;text-align:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
